import { useTranslation } from 'react-i18next';
import {
  StyledProductReleaseTag,
  StyledProductReleaseTagLabel,
} from '../styled';

export const ProductReleaseTag = () => {
  const { t } = useTranslation('common');
  return (
    <StyledProductReleaseTag>
      <StyledProductReleaseTagLabel variant="body2">
        {t('whats_new_modal.product_release')}
      </StyledProductReleaseTagLabel>
    </StyledProductReleaseTag>
  );
};
